import { devError } from '../../utils/log';
import { resolveFlag } from '../launchDarkly';

export type SoundEffect = 'click' | 'popup-open' | 'popup-close' | 'daily-bonus-open' | 'toggle' | 'new-tier-congrats';

class SoundEffects {
  private sounds = new Map([
    ['click', '/sounds/click.mp3'],
    ['popup-open', '/sounds/popup-open.mp3'],
    ['popup-close', '/sounds/popup-close.mp3'],
    ['daily-bonus-open', '/sounds/daily-bonus-open.mp3'],
    ['toggle', '/sounds/toggle.mp3'],
    ['new-tier-congrats', '/sounds/new-tier-congrats.mp3'],
  ]);

  private fetchedSounds: Map<SoundEffect, HTMLAudioElement> = new Map();

  currentAudioNode: HTMLAudioElement | null = null;

  private addSound(name: SoundEffect, src: string) {
    const audio = new Audio();
    audio.src = src;
    audio.autoplay = true;
    audio.muted = true;
    audio.load();
    this.fetchedSounds.set(name, audio);
    return audio;
  }

  private async play() {
    if (this.currentAudioNode) {
      this.currentAudioNode.muted = false;
      await this.currentAudioNode.play();
      this.currentAudioNode.remove();
      this.currentAudioNode.addEventListener('ended', () => {
        this.currentAudioNode = null;
      });
    }
  }

  public playSound(name: SoundEffect, bypassFF = false) {
    const soundsEnabledFF = bypassFF || resolveFlag('sound_effects', false);
    const disabledByUser = localStorage.getItem('disable_sounds');

    if (!soundsEnabledFF || disabledByUser) {
      return;
    }

    const soundFromSources = this.sounds.get(name);

    if (!soundFromSources) {
      devError(`Sound ${name} not found`);
      return;
    }

    let sound = this.fetchedSounds.get(name);
    try {
      if (!sound) {
        sound = this.addSound(name, soundFromSources);

        if (!sound) {
          devError(`Sound ${name} could not be added to fetchedSounds`);
          return;
        }
      }

      this.stopCurrentSound();
      this.currentAudioNode = sound;
      void this.play();
    } catch (err) {
      devError('Error while playing sound', err);
    }
  }

  public stopCurrentSound() {
    if (this.currentAudioNode) {
      this.currentAudioNode.pause();
      this.currentAudioNode.currentTime = 0;
      this.currentAudioNode = null;
    }
  }
}

const soundEffects = new SoundEffects();

export default soundEffects;
